import { NetworkStatus, QueryHookOptions, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { TokenQuery } from '../queries/swarmx/TokenQuery'
import {
  TokenQuery as TokenQueryGQL,
  TokenQueryVariables,
} from '../types/swarmx/graphql'
import { normalizeToken } from '../utils/dotc'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'

const useToken = (
  id: string,
  options?: QueryHookOptions<TokenQueryGQL, TokenQueryVariables>
) => {
  const { data, loading, error, networkStatus, refetch } = useQuery(
    TokenQuery,
    {
      fetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      ...options,
      variables: {
        id: unifyAddress(id),
      },
    }
  )

  const token = useMemo(() => {
    if (!data?.asset) return null
    return normalizeToken(data.asset)
  }, [data?.asset])

  return useMemo(
    () => ({
      token,
      loading:
        loading ||
        ![
          NetworkStatus.ready,
          NetworkStatus.error,
          NetworkStatus.poll,
        ].includes(networkStatus),
      error,
      refetch,
      refetching: [NetworkStatus.poll].includes(networkStatus),
    }),
    [error, loading, networkStatus, refetch, token]
  )
}

export default useToken
